<template>
   <div class="promotion_coupon">
      <Delete :delete_message="delete_message" :show="show_delete_modal" @close="$store.commit('show_delete_modal',false)" @delete="deletePromotionCoupon()"/>

      <Modal :show="show_create_modal" content_class="col-12 col-md-10 col-lg-9 col-xl-8" @close="$store.commit('show_create_modal',false)">
         <template slot="title">
            <div class="title">Add Promotional Coupons</div>
            <div class="subtitle">Provide the coupon details</div>
         </template>
         <template slot="content">
            <div>
               <Wizard 
                  :reset="resetForm"
                  :loading="loading"
                  :forms="[
                     PromotionCouponModel.forms.mainDetails,
                     PromotionCouponModel.forms.lockRules,
                     PromotionCouponModel.forms.otherConfigs,
                  ]"
                  @submit-form="addPromotionCoupon"
               />
            </div>
         </template>
      </Modal>

      <Modal :show="show_edit_modal" content_class="col-12 col-md-10 col-lg-9 col-xl-8" @close="$store.commit('show_edit_modal',false)">
         <template slot="title">
            <div class="title">Edit Promotional Coupons</div>
            <div class="subtitle">Provide the coupon details</div>
         </template>
         <template slot="content">
            <div>
               <Wizard 
                  :reset="resetForm"
                  :loading="loading"
                  :forms="[
                     PromotionCouponModel.forms.mainDetails,
                     PromotionCouponModel.forms.lockRules,
                     PromotionCouponModel.forms.otherConfigs,
                  ]"
                  @submit-form="updatePromotionCoupon"
               />
            </div>
         </template>
      </Modal>

      <div class="top-actions clearfix">
         <div class="btn btn-primary btn-r" @click="$store.commit('show_create_modal',true)">
            Add Promotion Coupon <i class="fa fa-plus"></i>
         </div>
      </div>
      
      <Table v-bind="PromotionCouponModel.tables.promotion_coupon.props" :data="promotion_coupons" @on-action="handleActions">
         <template slot-scope="{ row }" slot="from">
            <strong class="tx-small">{{ dayjs(row.from).format('DD-MM-YYYY HH:mm') }}</strong>
         </template>
         <template slot-scope="{ row }" slot="to">
            <strong class="tx-small">{{ dayjs(row.to).format('DD-MM-YYYY HH:mm') }}</strong>
         </template>
      </Table>
   </div>
</template>

<script>
import promotion_coupon from "./promotion_coupon.store";

export default {
   beforeDestroy () {
      this.$store.unregisterModule('promotion_coupon')
      Event.$off('select-field-changed')
   },
   created(){
      Event.$emit('loader:show',true)
      utils.registerModule('promotion_coupon',promotion_coupon,this.$store)

      Event.$on('select-field-changed',(payload) => {
         this.selectFieldChanged(payload)
      })
   },
   components:{
      Delete: () => import("wino-template/components/delete"),
      Modal: () => import("wino-template/components/modal"),
      Wizard: () => import("clarks/components/wizard"),
      Table: () => import("clarks/components/ivu-table"),
   },
   data (){
      return {
         dayjs
      };
   },
   computed: {
      ...mapGetters([
         'PromotionCouponModel',
         'promotion_coupons',
         'show_create_modal',
         'show_edit_modal',
         'resetForm',
         'show_delete_modal',
         'loading',
         'delete_message',
      ])
   },
   methods: {
      ...mapActions([
         'fetchData',
         'selectFieldChanged',
         'addPromotionCoupon',
         'deletePromotionCoupon',
         'updatePromotionCoupon',
         'handleActions',
      ]),
   },
   async mounted(){
      utils.registerModule('promotion_coupon',promotion_coupon,this.$store)
      await this.fetchData()
   }
}
</script>

<style lang="scss">
   .promotion_coupon{
      
   }
</style>